import React from "react";
import axios from "axios";
import { ThemeProvider } from "@material-ui/core/styles";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { createBrowserHistory } from "history";
import firebase from "firebase/app";
import "firebase/storage";

import Login from "./components/auth/login/Login";
import Register from "./components/auth/register/Register";
import Admin from "./layout/Admin";

import { backendUrl } from "./config/keys";
import styles from "./styles/app.module.css";
import { theme } from "./theme/theme";
import { firebaseConfig } from "./config/keys";

import { setUser } from "./containers/app/actions";
import { connect } from "react-redux";
import BackDrop from "./components/utils/BackDrop/BackDrop";
import CombineComp from "./components/CombineComp/CombineComp";

firebase.initializeApp(firebaseConfig);
export const storage = firebase.storage();

axios.interceptors.request.use(async (config) => {
  config.url = backendUrl + config.url;
  config.headers = {
    ...config.headers,
  };
  return config;
});

const hist = createBrowserHistory();

const App = (props) => {
  const [loaded, setLoaded] = React.useState(false);

  React.useEffect(() => {
    if (localStorage.user) {
      axios({
        method: "post",
        url: "/getUser",
        data: {
          contactNum: localStorage.getItem("user"),
        },
      })
        .then((res) => {
          if (res.data.data && res.data.data != null) {
            props.setUser(res.data.data);
          }
          setLoaded(true);
        })
        .catch((err) => {
          setLoaded(true);
        });
    } else {
      setLoaded(true);
    }
  }, []);

  return (
    <div className={styles.app}>
      {!loaded && <BackDrop />}

      {loaded && (
        <Router history={hist}>
          <ThemeProvider theme={theme}>
            <CombineComp />
            <Switch>
              <Route path="/login" component={Login} />
              <Route path="/register" component={Register} />

              <Admin />
            </Switch>
          </ThemeProvider>
        </Router>
      )}
    </div>
  );
};
export default connect(null, { setUser })(App);
